export const getSvgFilter = (color) => {
  const hexToRgb = (hex) => {
    if (!hex || typeof hex !== "string") return [0, 0, 0];
    const cleanHex = hex.startsWith("#") ? hex.slice(1) : hex;
    const r = Number.parseInt(cleanHex.slice(0, 2), 16);
    const g = Number.parseInt(cleanHex.slice(2, 4), 16);
    const b = Number.parseInt(cleanHex.slice(4, 6), 16);
    return [r, g, b];
  };

  const [r, g, b] = hexToRgb(color);
  return `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='recolor' color-interpolation-filters='sRGB'%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 ${
    r / 255
  } 0 0 0 0 ${g / 255} 0 0 0 0 ${
    b / 255
  } 0 0 0 1 0'/%3E%3C/filter%3E%3C/svg%3E#recolor")`;
};

export const extractId = (str) => {
  if (typeof str !== "string") return undefined;

  const lastParenIndex = str.lastIndexOf("(");
  const lastClosingParenIndex = str.lastIndexOf(")");

  // Ensure both parentheses exist and are in the expected order
  if (
    lastParenIndex === -1 ||
    lastClosingParenIndex === -1 ||
    lastParenIndex >= lastClosingParenIndex
  ) {
    return undefined;
  }

  // Extract the content between the last parentheses
  const extracted = str.substring(lastParenIndex + 1, lastClosingParenIndex);

  // If the extracted string is empty, return undefined
  if (extracted.length === 0) {
    return undefined;
  }
  console.log(`Extracted ID: ${extracted}`);
  return extracted;
};
